<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <img v-if="dataRow && dataRow.image" :src="MEDIA_URL+dataRow.image" class="img-thumbnail" style="max-width: 200px;" alt="">
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">وصف مختصر - عربي:</label>
          <div>{{ title }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">وصف مختصر - إنجليزي:</label>
          <div>{{ titleEn }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">الموضوع - عربي:</label>
          <div><pre>{{ subject }}</pre></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">الموضوع - إنجليزي:</label>
          <div class="english-input"><pre>{{ subjectEn }}</pre></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الموضوع:</label>
          <div>{{ (isActive)? 'منشور' : 'غير منشور' }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ForumsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: '',
      titleEn: '',
      subject: '',
      subjectEn: '',
      image: null,
      isActive: true,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  created(){
    if(this.dataRow){
      this.title = this.dataRow.title;
      this.titleEn = this.dataRow.titleEn;
      this.subject = this.dataRow.subject;
      this.subjectEn = this.dataRow.subjectEn;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
